<template>
  <div class="wtv-gallery">
    <div class="wtv-gallery-content">
      <img
        v-show="currentImageUrl"
        class="wtv-gallery-image"
        :src="currentImageUrl"
        alt="Текущая фотография отеля"
        @click="goToSlide"
      />
      <template v-if="currentImageUrl">
        <div class="wtv-gallery-left wtv-icon" @click="lastSlide"></div>
        <div class="wtv-gallery-length">
          {{ currentSlide + 1 }}/{{ images.length }}
        </div>
        <div class="wtv-gallery-right wtv-icon" @click="nextSlide"></div>
      </template>
    </div>
    <div class="wtv-gallery-thumbs">
      <div
        class="wtv-gallery-thumb"
        v-for="(image, i) in images"
        :key="image"
        @click="currentSlide = i"
        :class="{ 'wtv-active': currentSlide === i }"
      >
        <img class :src="image" alt />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Gallery',
  props: {
    images: Array,
  },
  data() {
    return {
      currentSlide: 0,
    };
  },
  computed: {
    currentImageUrl: {
      get() {
        return this.images[this.currentSlide];
      },
    },
  },
  methods: {
    goToSlide(e = window.event) {
      const imageWidth = e.target.width;
      return e.offsetX / imageWidth > 0.3 ? this.nextSlide() : this.lastSlide();
    },
    lastSlide() {
      const slide = this.currentSlide;
      this.currentSlide = slide === 0 ? this.images.length - 1 : slide - 1;
    },
    nextSlide() {
      const slide = this.currentSlide;
      this.currentSlide = slide === this.images.length - 1 ? 0 : slide + 1;
    },
  },
};
</script>

<style scoped>
.wtv-gallery-right,
.wtv-gallery-left {
  position: absolute;
  z-index: 1;
  left: 0;
  bottom: 0;
  height: 32px;
  width: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--color-bg);
  cursor: pointer;
}
.wtv-gallery-left:before,
.wtv-gallery-right:before {
  width: 100%;
  text-align: center;
  content: '\f054';
  font-size: 18px;
  color: var(--color-main);
}
.wtv-gallery-left:before {
  content: '\f053';
}
.wtv-gallery-image {
  width: 100%;
  height: 100%;
  display: flex;
  object-fit: cover;
  cursor: pointer;
  background-color: var(--color-text);
}
.wtv-gallery-left,
.wtv-gallery-right,
.wtv-gallery-length {
  position: absolute;
  left: unset;
  bottom: 12px;
}
.wtv-gallery-close:before,
.wtv-gallery-left:before,
.wtv-gallery-right:before {
  font-size: 18px;
}
.wtv-gallery-length {
  width: 32px;
  bottom: 12px;
  text-align: center;
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-weight: 600;
  color: #fff;
}
.wtv-gallery-right {
  margin-left: 64px;
}
.wtv-gallery-left {
  margin-left: -64px;
}
.wtv-gallery {
  position: relative;
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  background-color: var(--color-text);
  align-items: flex-start;
  justify-content: center;
  user-select: none;
}
.wtv-gallery-content {
  position: relative;
  flex: 4 0 575px;
  max-width: 100%;
  height: 401px;
  display: flex;
  flex-direction: column;
  background-color: var(--color-text);
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
@media (max-width: 575px) {
  .wtv-gallery-content {
    height: 250px;
  }
}
.wtv-gallery-thumbs {
  flex: 2 0 200px;
  display: flex;
  flex-wrap: wrap;
  border-top: 1px solid var(--color-paper);
  border-left: 1px solid var(--color-paper);
}
.wtv-gallery-thumb {
  flex: 1 1 100px;
  height: 50px;
  border-right: 1px solid var(--color-paper);
  border-bottom: 1px solid var(--color-paper);
  cursor: pointer;
}
.wtv-gallery-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.wtv-gallery-thumb.wtv-active img {
  opacity: 0.3;
}
</style>
